import { Injectable } from '@angular/core';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class AnbieterUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 'anbieter';

  constructor() {
    super(AnbieterUrlService.URL_PARAMETER, 'ban');
  }
}
